var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.game_infos),function(game_info,idx){return _c('li',{key:idx},[_c('router-link',{attrs:{"to":{ name: 'game', params: { identifier: game_info.identifier } }}},[_vm._v(_vm._s(game_info["name"]["zh-Hans"])+" ")])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }